import { render } from "./naviConfig.vue?vue&type=template&id=428ff922&scoped=true"
import script from "./naviConfig.vue?vue&type=script&lang=js"
export * from "./naviConfig.vue?vue&type=script&lang=js"

import "./naviConfig.vue?vue&type=style&index=0&id=428ff922&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428ff922"]])

export default __exports__